<template>
  <div>
    <v-app-bar
      app
      elevation="0"
      style="border-bottom: 1px solid grey !important"
    >
      <v-app-bar-nav-icon
        :disabled="!isUserLoggedIn"
        @click.stop="drawer = !drawer"
      ></v-app-bar-nav-icon>

      <span
        style="cursor: pointer"
        @click="goHome"
        class="text--secondary text-h6 d-none d-sm-flex"
      >
        Consumer Application Self Service
      </span>
      <span class="text--secondary text-h6 d-flex d-sm-none"> CASS </span>

      <v-spacer></v-spacer>

      <theme-button v-if="isUserLoggedIn"></theme-button>

      <v-tooltip v-if="isUserLoggedIn && isUserAdmin" bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            class="mr-1"
            v-bind="attrs"
            v-on="on"
            :loading="maintenanceLoading"
            :color="maintenanceEnabled ? 'red' : '#646464'"
            @click="openMaintenanceDialog"
          >
            <v-icon>mdi-alert-octagon</v-icon>
          </v-btn>
        </template>
        <span>UI Maintenance Mode</span>
      </v-tooltip>

      <v-btn
        v-if="!isUserLoggedIn"
        icon
        :disabled="!isUserLoggedIn"
        @click="SignIn()"
        color="#646464"
        class="mr-1"
      >
        <v-icon>mdi-login</v-icon>
      </v-btn>

      <v-menu v-if="isUserLoggedIn && userInfo" v-model="menu" offset-y>
        <template v-slot:activator="{ on, attrs }">
          <div>
            <v-badge
              v-if="isUserAdmin"
              color="red"
              icon="mdi-star"
              offset-x="25px"
              offset-y="25px"
            >
              <v-list-item-avatar class="mr-3" v-bind="attrs" v-on="on">
                <img v-if="userPhoto" :src="userPhoto" />
                <v-avatar v-if="!userPhoto" color="#006C27" size="40">
                  <span class="white--text">{{ nameinitials }}</span>
                </v-avatar>
              </v-list-item-avatar>
            </v-badge>
            <v-list-item-avatar
              class="mr-3"
              v-bind="attrs"
              v-on="on"
              v-if="!isUserAdmin"
            >
              <img v-if="userPhoto" :src="userPhoto" />
              <v-avatar v-if="!userPhoto" color="#006C27" size="40">
                <span class="white--text">{{ nameinitials }}</span>
              </v-avatar>
            </v-list-item-avatar>
          </div>
        </template>

        <v-card>
          <v-list>
            <v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-account-outline</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title
                  >{{ userInfo.givenName }}
                  {{ userInfo.surname }}</v-list-item-title
                >
                <v-list-item-subtitle>
                  <div>{{ userInfo.jobTitle }}</div>
                  <div
                    :style="
                      isUserAdmin
                        ? 'color: red; cursor: pointer'
                        : 'cursor: pointer'
                    "
                    v-if="isUserAdmin"
                    @click="toogleAdmin"
                  >
                    CASS Administrator
                  </div>
                  <div v-if="!isUserAdmin">CASS User</div>
                  <div v-if="isBetaUser">Beta User</div>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-star-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content class="mt-1">
                <v-list-item-title>Active Environments</v-list-item-title>
                <v-list-item-subtitle>
                  <template v-for="(env, index) in userEnvironments">
                    <div :key="index">{{ env }}</div>
                  </template>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="userDiagnostics">
              <v-list-item-icon>
                <v-icon>mdi-information-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content class="mt-1">
                <v-list-item-title>Auth Diagnostics</v-list-item-title>
                <v-list-item-subtitle>
                  <template v-if="isExternalDiagnosticsUser">
                    <div>User Type: {{ userDiagnostics.userType || "-" }}</div>
                    <div>
                      Auth Checked:
                      {{
                        userDiagnostics.authCheckedAt
                          ? formatDiagnosticsTime(userDiagnostics.authCheckedAt)
                          : "-"
                      }}
                    </div>
                    <div>
                      Roles Checked:
                      {{
                        userDiagnostics.rolesCheckedAt
                          ? formatDiagnosticsTime(userDiagnostics.rolesCheckedAt)
                          : "-"
                      }}
                    </div>
                    <div>
                      Owner Ref:
                      {{
                        userDiagnostics.projection && userDiagnostics.projection.ownerRef
                          ? userDiagnostics.projection.ownerRef
                          : "-"
                      }}
                    </div>
                  </template>
                  <template v-else>
                    <div>Source: {{ userDiagnostics.authSource }}</div>
                    <div v-if="userDiagnostics.userType">
                      User Type: {{ userDiagnostics.userType }}
                    </div>
                    <div v-if="!isApplicationLimitMissing">
                      App Limit: {{ diagnosticsApplicationLimit }}
                    </div>
                    <div v-else class="red--text text--darken-2">
                      App Limit: MISSING
                    </div>
                    <div v-if="!isCertificateLimitMissing">
                      Cert Limit: {{ diagnosticsCertificateLimit }}
                    </div>
                    <div v-else class="red--text text--darken-2">
                      Cert Limit: MISSING
                    </div>
                    <div
                      v-if="typeof userDiagnostics.isGrantedForInternalAPIs === 'boolean'"
                    >
                      Internal API Access:
                      {{ userDiagnostics.isGrantedForInternalAPIs ? "yes" : "no" }}
                    </div>
                    <div v-if="userDiagnostics.decisionReasonCode">
                      Reason: {{ userDiagnostics.decisionReasonCode }}
                    </div>
                    <div v-if="userDiagnostics.authCheckedAt">
                      Auth Checked: {{ formatDiagnosticsTime(userDiagnostics.authCheckedAt) }}
                    </div>
                    <div v-if="userDiagnostics.rolesCheckedAt">
                      Roles Checked: {{ formatDiagnosticsTime(userDiagnostics.rolesCheckedAt) }}
                    </div>
                    <div v-if="userDiagnostics.projection">
                      Owner Ref: {{ userDiagnostics.projection.ownerRef || "-" }}
                    </div>
                    <div
                      v-if="userDiagnostics.projection && userDiagnostics.projection.ownerType"
                    >
                      Owner Type: {{ userDiagnostics.projection.ownerType }}
                    </div>
                    <div v-if="userDiagnostics.projection && userDiagnostics.projection.ext14">
                      Ext14: {{ userDiagnostics.projection.ext14 }}
                    </div>
                    <div v-if="userDiagnostics.projection && userDiagnostics.projection.email">
                      Projection Email: {{ userDiagnostics.projection.email }}
                    </div>
                    <div
                      v-if="userDiagnostics.projection && userDiagnostics.projection.displayName"
                    >
                      Projection Name: {{ userDiagnostics.projection.displayName }}
                    </div>
                    <div
                      v-if="
                        userDiagnostics.projection &&
                        typeof userDiagnostics.projection.isUnresolved === 'boolean'
                      "
                    >
                      Projection Unresolved:
                      {{ userDiagnostics.projection.isUnresolved ? "yes" : "no" }}
                    </div>
                    <div
                      v-if="
                        userDiagnostics.projection &&
                        userDiagnostics.projection.unresolvedReasonCode
                      "
                    >
                      Projection Reason:
                      {{ userDiagnostics.projection.unresolvedReasonCode }}
                    </div>
                    <div
                      v-if="
                        userDiagnostics.projection &&
                        typeof userDiagnostics.projection.isAmbiguous === 'boolean'
                      "
                    >
                      Projection Ambiguous:
                      {{ userDiagnostics.projection.isAmbiguous ? "yes" : "no" }}
                    </div>
                    <div
                      v-if="
                        userDiagnostics.projection &&
                        userDiagnostics.projection.isAmbiguous === true &&
                        userDiagnostics.projection.candidateCount
                      "
                    >
                      Projection Candidate Count:
                      {{ userDiagnostics.projection.candidateCount }}
                    </div>
                    <div
                      v-if="
                        userDiagnostics.projection &&
                        userDiagnostics.projection.isAmbiguous === true &&
                        userDiagnostics.projection.primarySelectionReason
                      "
                    >
                      Projection Selection:
                      {{ userDiagnostics.projection.primarySelectionReason }}
                    </div>
                    <div
                      v-if="
                        userDiagnostics.projection &&
                        userDiagnostics.projection.isAmbiguous === true &&
                        ambiguityAlternateLines(userDiagnostics.projection).length > 0
                      "
                    >
                      <div>Projection Alternates:</div>
                      <div
                        v-for="(line, lineIndex) in ambiguityAlternateLines(userDiagnostics.projection)"
                        :key="'profile-ambiguity-line-' + lineIndex"
                        class="profile-ambiguity-line"
                      >
                        {{ line }}
                      </div>
                    </div>
                  </template>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item-group>
              <v-list-item @click="logout()">
                <v-list-item-icon>
                  <v-icon>mdi-logout</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Logout</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-menu>

      <div class="d-flex align-center">
        <v-img
          alt="Schaeffler Logo"
          class="shrink mr-2"
          contain
          :src="$getImagePath('schaeffler-logo.svg')"
          transition="scale-transition"
        />
      </div>
    </v-app-bar>
    <v-navigation-drawer fixed v-model="drawer" temporary :width="325">
      <v-list nav dense>
        <v-list-item-group>
          <v-list-item @click="home">
            <v-list-item-icon>
              <v-icon color="#006c27">mdi-home-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="subtitle-1 text--secondary"
              >Home</v-list-item-title
            >
          </v-list-item>

          <v-list-item @click="apiportal">
            <v-list-item-icon>
              <v-icon color="#006c27">mdi-api</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="subtitle-1 text--secondary"
              >API Portal</v-list-item-title
            >
          </v-list-item>

          <v-list-item @click="developerportal">
            <v-list-item-icon>
              <v-icon color="#006c27">mdi-code-tags</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="subtitle-1 text--secondary"
              >Developer Portal</v-list-item-title
            >
          </v-list-item>

          <v-list-item @click="permissionModel">
            <v-list-item-icon>
              <v-icon color="#006c27">mdi-key-chain</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="subtitle-1 text--secondary"
              >Permission Models</v-list-item-title
            >
          </v-list-item>

          <v-list-item @click="environments">
            <v-list-item-icon>
              <v-icon color="#006c27"
                >mdi-numeric-3-box-multiple-outline</v-icon
              >
            </v-list-item-icon>
            <v-list-item-title class="subtitle-1 text--secondary"
              >Environments</v-list-item-title
            >
          </v-list-item>

          <v-list-item @click="feedback">
            <v-list-item-icon>
              <v-icon color="#006c27">mdi-comment-quote-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="subtitle-1 text--secondary"
              >Feedback</v-list-item-title
            >
          </v-list-item>

          <v-list-item @click="mtlsaccount">
            <v-list-item-icon>
              <v-icon color="#006c27">mdi-certificate-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="subtitle-1 text--secondary"
              >Non-CASS Apps
            </v-list-item-title>
          </v-list-item>

          <v-list-item @click="openpermissionrequest">
            <v-list-item-icon>
              <v-icon color="#006c27">mdi-account-key</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="subtitle-1 text--secondary"
              >Open Permission Requests
            </v-list-item-title>
          </v-list-item>

          <v-list-item v-if="isUserAdmin" @click="opendeletedapps">
            <v-list-item-icon>
              <v-icon color="red">mdi-delete-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="subtitle-1 text--secondary"
              >Deleted Apps
            </v-list-item-title>
          </v-list-item>

          <v-list-item @click="community">
            <v-list-item-icon>
              <v-icon color="#006c27">mdi-account-group-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="subtitle-1 text--secondary"
              >Community</v-list-item-title
            >
          </v-list-item>
          <v-list-item v-if="isUserAdmin" @click="manage">
            <v-list-item-icon>
              <v-icon color="#006c27">mdi-cog-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="subtitle-1 text--secondary"
              >Manage</v-list-item-title
            >
          </v-list-item>
          <v-list-item v-if="isUserAdmin" @click="resolverDiagnostics">
            <v-list-item-icon>
              <v-icon color="#006c27">mdi-database-search-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="subtitle-1 text--secondary"
              >Resolver Diagnostics</v-list-item-title
            >
          </v-list-item>
          <v-list-item v-if="isUserAdmin" @click="backgroundJobs">
            <v-list-item-icon>
              <v-icon color="#006c27">mdi-timer-cog-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="subtitle-1 text--secondary"
              >Background Jobs</v-list-item-title
            >
          </v-list-item>
          <v-list-item v-if="isUserAdmin" @click="smtAdminConsent">
            <v-list-item-icon>
              <v-icon color="#006c27">mdi-file-table-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="subtitle-1 text--secondary"
              >SMT Admin Consent</v-list-item-title
            >
          </v-list-item>
          <v-list-item v-if="isUserAdmin" @click="authFailures">
            <v-list-item-icon>
              <v-icon color="#006c27">mdi-shield-alert-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="subtitle-1 text--secondary"
              >Auth Failures</v-list-item-title
            >
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <v-dialog v-model="maintenanceDialog" max-width="700">
      <v-card>
        <v-card-title class="text--secondary">
          UI Maintenance Mode Control
        </v-card-title>
        <v-card-text>
          <v-alert dense outlined type="error" border="left" colored-border>
            <strong>Warning:</strong> Activating maintenance mode immediately
            blocks all non-admin users from every protected API endpoint.
            Existing non-admin sessions are interrupted and redirected to the
            maintenance screen on their next request.
          </v-alert>
          <v-alert dense outlined type="warning" border="left" colored-border>
            Proceed only when planned maintenance is confirmed and stakeholder
            communication is complete.
          </v-alert>

          <div class="d-flex align-center mt-2">
            <v-chip :color="maintenanceEnabled ? '#b71c1c' : '#006c27'" dark>
              {{ maintenanceEnabled ? "ACTIVE" : "INACTIVE" }}
            </v-chip>
            <span class="ml-3" style="font-size: 0.82rem">
              Last update: {{ maintenanceUpdatedAt || "-" }}
              <span v-if="maintenanceUpdatedBy"> by {{ maintenanceUpdatedBy }}</span>
            </span>
          </div>

          <v-checkbox
            v-if="!maintenanceEnabled"
            v-model="maintenanceActivationConfirmed"
            :disabled="maintenanceLoading"
            color="#b71c1c"
            class="mt-4"
            label="I understand this will block all non-admin users immediately."
          ></v-checkbox>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text :disabled="maintenanceLoading" @click="maintenanceDialog = false">
            Close
          </v-btn>
          <v-btn
            v-if="!maintenanceEnabled"
            color="#b71c1c"
            dark
            :loading="maintenanceLoading"
            :disabled="maintenanceLoading || !maintenanceActivationConfirmed"
            @click="setMaintenanceMode(true)"
          >
            Activate Maintenance
          </v-btn>
          <v-btn
            v-else
            color="#006c27"
            dark
            :loading="maintenanceLoading"
            :disabled="maintenanceLoading"
            @click="setMaintenanceMode(false)"
          >
            Deactivate Maintenance
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ThemeButton from "./ThemeButton.vue";
import cass from "../api/cass";
import { formatAmbiguityAlternateLine } from "../utils/ownerProjectionAmbiguity";

export default {
  name: "SchaefflerHeader",
  components: { ThemeButton },
  data() {
    return {
      drawer: false,
      isUserAdmin: false,
      isBetaUser: false,
      isUserLoggedIn: false,
      userInfo: null,
      userPhoto: null,
      userEnvironments: null,
      userDiagnostics: null,
      menu: false,
      maintenanceDialog: false,
      maintenanceLoading: false,
      maintenanceEnabled: false,
      maintenanceUpdatedAt: null,
      maintenanceUpdatedBy: null,
      maintenanceActivationConfirmed: false,
    };
  },
  created() {
    console.log("created");
    this.$emitter.on("quit_session", () => {
      console.log("quit_session");
      this.userInfo = null;
      this.userDiagnostics = null;
      this.isUserLoggedIn = false;
      this.maintenanceDialog = false;
      this.maintenanceActivationConfirmed = false;
    });
    this.$emitter.on("login", () => {
      console.log("SchaefflerHeader: got login event");
      this.userInfo = this.$userData.graphUserInfo;
      this.userPhoto = this.$userData.graphUserPhoto;
      this.userEnvironments = this.$userData.cass.environments;
      this.userDiagnostics = this.$userData.cass.diagnostics;
      this.isUserAdmin = this.$userData.cass.isUserAdmin;
      this.isBetaUser = this.$userData.cass.isBetaUser;
      this.isUserLoggedIn = true;
      if (this.isUserAdmin) {
        this.loadMaintenanceModeState();
      }
    });
  },
  mounted() {
    console.log("mounted");
  },
  computed: {
    diagnosticsApplicationLimit: function () {
      if (!this.$userData || !this.$userData.cass) {
        return undefined;
      }
      return this.$userData.cass.applicationLimit;
    },
    diagnosticsCertificateLimit: function () {
      if (!this.$userData || !this.$userData.cass) {
        return undefined;
      }
      return this.$userData.cass.certificateLimit;
    },
    isApplicationLimitMissing: function () {
      return (
        this.diagnosticsApplicationLimit === null ||
        this.diagnosticsApplicationLimit === undefined
      );
    },
    isCertificateLimitMissing: function () {
      return (
        this.diagnosticsCertificateLimit === null ||
        this.diagnosticsCertificateLimit === undefined
      );
    },
    isExternalDiagnosticsUser: function () {
      if (!this.userDiagnostics || !this.userDiagnostics.userType) {
        return false;
      }
      return (
        String(this.userDiagnostics.userType).trim().toLowerCase() ===
        "external_customer"
      );
    },
    nameinitials: function () {
      if (
        this.userInfo !== null &&
        this.userInfo.givenName !== null &&
        this.userInfo.surname !== null
      ) {
        return (
          this.userInfo.givenName.charAt(0) + this.userInfo.surname.charAt(0)
        );
      }
      if (this.userInfo.displayName !== null) {
        return this.userInfo.displayName.charAt(0).toUpperCase();
      }
      return "S";
    },
  },
  methods: {
    toogleAdmin() {
      this.$userData.cass.isUserAdmin = !this.$userData.cass.isUserAdmin;
      if (this.$userData.cass.isUserAdmin) {
        console.log("Admin mode enabled");
      } else {
        console.log("Admin mode disabled");
      }
    },
    formatDiagnosticsTime(value) {
      const dateValue = new Date(value);
      if (Number.isNaN(dateValue.getTime())) {
        return value;
      }
      return dateValue.toLocaleString();
    },
    ambiguityAlternateLines(projection) {
      const alternates = Array.isArray(projection && projection.candidates)
        ? projection.candidates
        : [];
      return alternates.map((alternate) => formatAmbiguityAlternateLine(alternate));
    },
    openMaintenanceDialog() {
      this.maintenanceDialog = true;
      this.maintenanceActivationConfirmed = false;
      this.loadMaintenanceModeState();
    },
    loadMaintenanceModeState() {
      if (!this.isUserAdmin) {
        return;
      }
      this.maintenanceLoading = true;
      cass
        .getMaintenanceMode()
        .then((response) => {
          this.maintenanceEnabled = response.data.enabled;
          this.maintenanceUpdatedBy = response.data.updatedBy || null;
          if (response.data.updatedAt) {
            this.maintenanceUpdatedAt = new Date(
              response.data.updatedAt
            ).toLocaleString();
          } else {
            this.maintenanceUpdatedAt = null;
          }
        })
        .catch((error) => {
          console.error("Could not load maintenance mode state", error);
        })
        .finally(() => {
          this.maintenanceLoading = false;
        });
    },
    setMaintenanceMode(enabled) {
      this.maintenanceLoading = true;
      cass
        .patchMaintenanceMode(enabled)
        .then((response) => {
          this.maintenanceEnabled = response.data.enabled;
          this.maintenanceUpdatedBy = response.data.updatedBy || null;
          if (response.data.updatedAt) {
            this.maintenanceUpdatedAt = new Date(
              response.data.updatedAt
            ).toLocaleString();
          } else {
            this.maintenanceUpdatedAt = null;
          }
          this.maintenanceActivationConfirmed = false;
          this.maintenanceDialog = false;
        })
        .catch((error) => {
          console.error("Could not update maintenance mode state", error);
        })
        .finally(() => {
          this.maintenanceLoading = false;
        });
    },
    goHome() {
      if (!this.isUserLoggedIn) {
        return;
      }
      if (this.$route.name != "Home") {
        this.$router
          .push({
            name: "Home",
          })
          .catch(() => {
            console.log("Something bad happend .. start over");
            window.location.reload();
          });
      }
    },
    SignIn() {
      //console.log("SignIn");
      //this.$authService.signIn();
    },
    home() {
      this.goHome();
      this.drawer = false;
    },
    developerportal() {
      let url = "https://developer.schaeffler.com";

      window.open(url, "_blank").focus();
      this.drawer = false;
    },
    apiportal() {
      let url = "https://apiportal-dev.schaeffler.com/";

      window.open(url, "_blank").focus();
      this.drawer = false;
    },
    logout() {
      console.log("LOGOUT");
      this.$router
        .push({
          name: "Logout",
        })
        .catch((err) => {
          console.log(err);
          console.log("Something bad happend .. start over");
          window.location.reload();
        });
    },
    permissionModel() {
      if (this.$route.name != "PermissionModel") {
        this.$router
          .push({
            name: "PermissionModel",
          })
          .catch(() => {
            console.log("Something bad happend .. start over");
            window.location.reload();
          });
      }
    },
    environments() {
      if (this.$route.name != "Environments") {
        this.$router
          .push({
            name: "Environments",
          })
          .catch(() => {
            console.log("Something bad happend .. start over");
            window.location.reload();
          });
      }
    },
    feedback() {
      if (this.$route.name != "Feedback") {
        this.$router
          .push({
            name: "Feedback",
          })
          .catch(() => {
            console.log("Something bad happend .. start over");
            window.location.reload();
          });
      }
    },
    openpermissionrequest() {
      if (this.$route.name != "OpenPermissionRequest") {
        this.$router
          .push({
            name: "OpenPermissionRequest",
          })
          .catch(() => {
            console.log("Something bad happend .. start over");
            window.location.reload();
          });
      }
    },
    opendeletedapps() {
      if (this.$route.name != "DeletedApps") {
        this.$router
          .push({
            name: "DeletedApps",
          })
          .catch(() => {
            console.log("Something bad happend .. start over");
            window.location.reload();
          });
      }
    },
    mtlsaccount() {
      if (this.$route.name != "NonCassApplications") {
        this.$router
          .push({
            name: "NonCassApplications",
          })
          .catch(() => {
            console.log("Something bad happend .. start over");
            window.location.reload();
          });
      }
    },
    community() {
      let url =
        "msteams://teams.microsoft.com/l/team/19%3aOGG-WbPKZOPQ66Tloj-o0NaNdDFInZT0QJORGHMlQyg1%40thread.tacv2/conversations?groupId=ac301a8b-1db4-45a3-8dd7-9bdb904de8c8&tenantId=67416604-6509-4014-9859-45e709f53d3f";
      window.open(url, "_blank").focus();
      this.drawer = false;
    },
    manage() {
      if (this.$route.name != "ManageUsers") {
        this.$router
          .push({
            name: "ManageUsers",
          })
          .catch(() => {
            console.log("Something bad happend .. start over");
            window.location.reload();
          });
      }
    },
    resolverDiagnostics() {
      if (this.$route.name != "ResolverDiagnostics") {
        this.$router
          .push({
            name: "ResolverDiagnostics",
          })
          .catch(() => {
            console.log("Something bad happend .. start over");
            window.location.reload();
          });
      }
    },
    backgroundJobs() {
      if (this.$route.name != "BackgroundJobs") {
        this.$router
          .push({
            name: "BackgroundJobs",
          })
          .catch(() => {
            console.log("Something bad happend .. start over");
            window.location.reload();
          });
      }
    },
    smtAdminConsent() {
      if (this.$route.name != "SmtAdminConsent") {
        this.$router
          .push({
            name: "SmtAdminConsent",
          })
          .catch(() => {
            console.log("Something bad happend .. start over");
            window.location.reload();
          });
      }
    },
    authFailures() {
      if (this.$route.name != "AuthFailures") {
        this.$router
          .push({
            name: "AuthFailures",
          })
          .catch(() => {
            console.log("Something bad happend .. start over");
            window.location.reload();
          });
      }
    },
  },
};
</script>

<style scoped>
.v-btn.v-btn--has-bg {
  text-transform: none;
  letter-spacing: 0;
  text-indent: 0;
}
.v-btn.v-btn--has-bg:hover {
  background-color: #006c27;
}

.v-btn.v-btn--text {
  text-transform: none;
  letter-spacing: 0;
  text-indent: 0;
}

.v-btn.v-btn--text:hover {
  background-color: white;
}

.v-btn.v-btn--plain {
  text-transform: none;
  letter-spacing: 0;
  text-indent: 0;
}

.v-btn.v-btn--plain:hover {
  background-color: white;
  color: #006c27;
}

.v-btn.v-btn--icon:hover {
  background-color: white !important;
  color: #006c27 !important;
}

.theme--light.v-btn.v-btn--disabled {
  color: white !important;
}

.theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
  background-color: #646464 !important;
  opacity: 0.4 !important;
}

.text-nospacing {
  letter-spacing: 0 !important;
  font-size: 0.75rem !important;
  font-weight: 400;
  line-height: 1.25rem;
  font-family: "Roboto", sans-serif !important;
}

.no-underline {
  text-decoration: none;
}

.profile-ambiguity-line {
  font-size: 0.78rem;
  line-height: 1.1rem;
  margin-left: 8px;
}
</style>
